import { BookHeart, NotebookPen } from 'lucide-react';
import type { Memory } from '@app/shared';
import type { WebModule } from '../../app/types.ts';
import { familyRecords, scoreText } from '../../platform/search.ts';
import { friendlyDate } from '../../platform/time.ts';

export const memoriesModule: WebModule = {
  id: 'memories',
  label: 'Memories',
  icon: BookHeart,
  path: '/memories',
  nav: { group: 'family', order: 20 },
  routes: [
    { path: 'memories', lazy: async () => ({ Component: (await import('./MemoriesScreens.tsx')).MemoriesScreen }) },
    { path: 'memories/:memoryId', lazy: async () => ({ Component: (await import('./MemoriesScreens.tsx')).MemoryScreen }) },
  ],
  quickActions: [{ id: 'memory', label: 'Memory', icon: NotebookPen, to: '/memories?add=1' }],
  async search(q, ctx) {
    const items = await familyRecords<Memory>('memories', ctx.familyId);
    return items
      .map((m) => ({ m, score: scoreText(q, [m.title, m.body]) }))
      .filter((x) => x.score > 0)
      .map(({ m, score }) => ({
        key: `memories:${m.id}`,
        title: m.title || m.body.slice(0, 60),
        subtitle: friendlyDate(m.date),
        to: `/memories/${m.id}`,
        group: 'Memories',
        icon: BookHeart,
        score,
      }));
  },
};
